import * as actionTypes from './actionTypes'
import moment from 'moment';

const initialState = {
  topRoutes: [],
  travellerTypes: {},
  otherDetails: {},
  lastUpdated: '',
  merchantId: ''
}

export default (state = initialState, { type, payload }) => {
  switch(type) {
    case actionTypes.DASHBOARD_DATA: {
      const { top_routes, traveller_types, ...rest } = payload.data.body;
      return {
        ...state,
        topRoutes: top_routes,
        travellerTypes: traveller_types,
        otherDetails: rest,
        lastUpdated: moment().format('lll')
      }
    }

    case actionTypes.SET_MERCHANT_ID: {
      return { ...state, merchantId: payload }
    }
    
    default:
      return state;
  }
}
